import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {request, handleRequestErrors} from '../../helpers/Requests'
import { spaceAndCapitalize } from '../../utilities/Forms.js'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class GettingStartedChecklist extends Component {
  constructor(props) {
    super(props);

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(index) {
    this.setState({ tabIndex: index });
  }

  renderCount(category) {
    const total = Object.entries(this.state.data[category])
    const done = total.filter(([key, value]) => value === true)

    return `(${done.length}/${total.length})`
  }

  renderCategory(category) {
    return (
      <TabPanel key={category}>
        {Object.entries(this.state.data[category]).map(([key, value]) => (
          <div className="checkbox-with-text" key={key}>
            <input type="checkbox" checked={value} readOnly />
            {this.renderTip(key)}
          </div>
        ))}
      </TabPanel>
    )

  }

  renderTip(key) {
    return this.keyLookup(key) || <label>{spaceAndCapitalize(key)}</label>
  }

  keyLookup(key) {
    const lookup = {
      //beginner
      device_created: <label>Create a <Link to={"/configuration/devices"} target="_blank" rel="noopener noreferrer">Device</Link></label>,
      profile_created: <label>Create a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      profile_assigned: <label>Assign a Profile to a <Link to={"/configuration/devices"} target="_blank" rel="noopener noreferrer">Device</Link></label>,
      device_active: <label>Set up your <a target="_blank" rel="noopener noreferrer"href='https://www.dreception.com/docs/quick-start-guide.pdf'>Device</a> on a tablet</label>,
      event_created: <label>Have a Visitor <Link to={"/exports/events"} target="_blank" rel="noopener noreferrer">Arrive & Leave</Link></label>,
      open_hours: <label>Add <Link to="settings/location" target="_blank" rel="noopener noreferrer">Open Hours</Link></label>,
      service_created: <label>Create <Link to="configuration/services" target="_blank" rel="noopener noreferrer">Services</Link></label>,
      booking_form_enabled: <label>Enable the <Link to="settings/location" target="_blank" rel="noopener noreferrer">Booking Form</Link></label>,
      planned_event_created: <label>Create an <Link to="/appointments" target="_blank" rel="noopener noreferrer">Appointment</Link></label>,

      //intermediate
      feedback_question_created: <label>Create <Link to={"/configuration/feedback"} target="_blank" rel="noopener noreferrer">Feedback Questions</Link></label>,
      feedback_question_assigned: <label>Assign Feedback Questions to a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      custom_attribute_created: <label>Create <Link to={"/configuration/custom-attributes"} target="_blank" rel="noopener noreferrer">Custom Attributes</Link></label>,
      custom_attribute_assigned: <label>Assign Custom Attributes to a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      auto_checkout_configured: <label>Set up <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Auto Checkout</Link></label>,
      tag_created: <label>Create <Link to={"/configuration/tags"} target="_blank" rel="noopener noreferrer">Tags</Link></label>,
      tag_assigned: <label>Assign Tags to a <Link to={"/people"} target="_blank" rel="noopener noreferrer">Person</Link></label>,
      role_created: <label>Create <Link to={"/configuration/roles"} target="_blank" rel="noopener noreferrer">Roles</Link></label>,
      role_assigned: <label>Assign Roles to a <Link to={"/people"} target="_blank" rel="noopener noreferrer">Person</Link></label>,
      relationship_created: <label>Add Relationships to <Link to={"/people"} target="_blank" rel="noopener noreferrer">People</Link></label>,
      import_ran: <label><Link to={"/imports"} target="_blank" rel="noopener noreferrer">Import</Link> existing people</label>,
      ticket_created: <label>Create a <Link to={"/support"} target="_blank" rel="noopener noreferrer">Support Ticket</Link></label>,

      //advanced
      staff_on_duty_active: <label>Enable <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Staff on Duty</Link> and add <Link to={"/people"} target="_blank" rel="noopener noreferrer">People</Link> to it</label>,
      auto_tag_enabled: <label>Enable Auto Tag on a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      information_image_added: <label>Add Information Images to a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      shift_created: <label>Set up <Link to={"/staff-fulfilment"} target="_blank" rel="noopener noreferrer">Staff Fulfilment</Link> Shifts</label>,
      holiday_created: <label>Create a <Link to={"/staff-holidays"} target="_blank" rel="noopener noreferrer">Staff Holiday</Link></label>,
      mass_mail_sent: <label>Send a <Link to={"/mass-mails"} target="_blank" rel="noopener noreferrer">Mass Mail</Link></label>,
      arrival_emails_active: <label>Enable Arrival emails on a <Link to={"/configuration/profiles"} target="_blank" rel="noopener noreferrer">Profile</Link></label>,
      email_template_created: <label>Configure <Link to={"/settings/email-templates"} target="_blank" rel="noopener noreferrer">Email Templates</Link></label>,
      data_retention_set: <label>Set a <Link to={"/settings/data-retention"} target="_blank" rel="noopener noreferrer">Data Retention</Link> policy</label>,
      customer_api_active: <label>Enable the Customer API on a <Link to={"/settings/users"} target="_blank" rel="noopener noreferrer">User</Link></label>
    }

    return lookup[key]
  }

  render() {
    const { data, tabIndex, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div className="widget">
          <h3>Getting Started Checklist</h3>

          <Tabs selectedIndex={tabIndex} onSelect={index => this.handleTabChange(index)}>
            <TabList>
              {Object.keys(data).map(category => (
                <Tab key={category}>{spaceAndCapitalize(category)} {this.renderCount(category)}</Tab>
              ))}
            </TabList>

            {Object.keys(data).map(category => this.renderCategory(category))}
          </Tabs>
        </div>
      );
    }
  }

  state = {
    data: null,
    tabIndex: 0,
    loaded: false,
    error: null
  };

  componentDidMount() {
    request("GET", `/v1/a/organisations/getting_started`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default GettingStartedChecklist;
